const LocaleState = {
  LocaleNotLoaded: 0,     //Locale file is not loaded
  LocaleLoading: 1,       //Locale file is loading
  LocaleLoaded: 2,        //Locale file has loaded
  LocaleFailedToLoad: 3   //Locale file failed to load
};

export default LocaleState;
